/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Event_Group_Option_LabelInputs */

const en_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} events)`)
};

const fr_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} événements)`)
};

const de_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} Ereignisse)`)
};

const it_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (eventi ${i?.count})`)
};

const ru_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} события)`)
};

const es_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} eventos)`)
};

const zh_cn2_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}（${i?.count} 事件）`)
};

const ja_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} イベント)`)
};

const hi_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} घटनाएँ)`)
};

const pt_pt2_event_group_option_label = /** @type {(inputs: Event_Group_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (eventos ${i?.count})`)
};

/**
* | output |
* | --- |
* | "{name} ({count} events)" |
*
* @param {Event_Group_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_option_label = /** @type {((inputs: Event_Group_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_option_label(inputs)
	if (locale === "de") return de_event_group_option_label(inputs)
	if (locale === "it") return it_event_group_option_label(inputs)
	if (locale === "ru") return ru_event_group_option_label(inputs)
	if (locale === "es") return es_event_group_option_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_option_label(inputs)
	if (locale === "ja") return ja_event_group_option_label(inputs)
	if (locale === "hi") return hi_event_group_option_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_option_label(inputs)
	return en_event_group_option_label(inputs)
});